<template>
  <div>
    <!-- Виджет внизу справа -->
    <div class="onboarding-prompt-card">
      <div class="onboarding-prompt-body">
        <p class="onboarding-prompt-emoji mb-2">🎬</p>
        <p class="onboarding-prompt-title mb-1">
          Узнайте за 4 минуты, как начать работать
        </p>
        <p class="onboarding-prompt-text mb-3">
          Короткий обзор сервиса — и можно приступать к делу
        </p>
        <button type="button" class="btn btn-primary btn-sm w-100 mb-2" @click="openVideo">
          Посмотреть обзор
        </button>
        <button type="button" class="btn btn-outline-secondary btn-sm w-100" @click="dontShowAgain">
          Больше не показывать
        </button>
      </div>
    </div>

    <!-- Модальное окно с видео -->
    <BaseModal
      v-if="showVideoModal"
      modal-title="Обзор сервиса"
      size="modal-xl"
      :opened="true"
      @close="closeVideo"
    >
      <div class="ratio ratio-16x9">
        <iframe
          src="https://rutube.ru/play/embed/b4b717c8544d79d45a6707354808e10b/"
          style="border: none;"
          allow="clipboard-write; autoplay"
          allowfullscreen
          webkitallowfullscreen
          mozallowfullscreen
        />
      </div>
    </BaseModal>
  </div>
</template>

<script>
import BaseModal from "@/components/Modal.vue";
import { updateUser } from "@/api/user";
import { Message, Messages } from "@/data/messages";

export default {
  name: "OnboardingPrompt",
  components: { BaseModal },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  emits: ["dismiss"],
  data() {
    return {
      showVideoModal: false,
    };
  },
  methods: {
    openVideo() {
      this.showVideoModal = true;
    },
    closeVideo() {
      this.showVideoModal = false;
    },
    async dontShowAgain() {
      const message = new Message();
      try {
        await updateUser(this.userId, { onboarded: true });
        message.type = "success";
        message.autoremove = 3;
        message.text = "Напоминание отключено";
        Messages.list.push(message);
        this.$emit("dismiss");
      } catch (e) {
        message.type = "failure";
        message.text =
          e.response?.data?.detail ||
          "Не удалось сохранить. Попробуйте снова.";
        Messages.list.push(message);
      }
    }
  },
};
</script>

<style scoped>
.onboarding-prompt-card {
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 1050;
  max-width: 380px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 0.5rem;
  background: var(--bs-body-bg, #fff);
  border: 1px solid var(--bs-border-color, #dee2e6);
}

.onboarding-prompt-body {
  padding: 1.25rem 1.5rem;
}

.onboarding-prompt-emoji {
  font-size: 1.75rem;
  line-height: 1;
  margin: 0;
}

.onboarding-prompt-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  color: var(--bs-body-color);
}

.onboarding-prompt-text {
  font-size: 0.875rem;
  margin: 0;
  color: var(--bs-secondary-color);
}

</style>
